import React from "react";
import Avatar from "@material-ui/core/Avatar";

const Avatars = {
  colorsMap: {
    'Cartman': '#E00',
    'Kyle': '#090',
    '_default_': '#888'
  },
  imageMap: {
    'Cartman': 'cartman.png',
    'Chef': 'chef.png',
    'Clyde': 'clyde.png',
    'Butters': 'butters.png',
    'Jimmy': 'jimmy.png',
    'Kenny': 'kenny.png',
    'Kyle': 'kyle.png',
    'Liane': 'liane.png',
    'Mr. Garrison': 'garrison.png',
    'Randy': 'randy.png',
    'Sharon': 'sharon.png',
    'Sheila': 'sheila.png',
    'Stan': 'stan.png',
    'Token': 'token.png',
    'Wendy': 'wendy.png',
    // 'Announcer': '',
    // 'Narrator': '',
  },
  hasAvatar: (name) => Avatars.imageMap.hasOwnProperty(name),
  sourceImage: (name) => Avatars.hasAvatar(name) ?
    process.env.PUBLIC_URL + '/avatars/' + Avatars.imageMap[name] : undefined,
  avatarColor: (name) => Avatars.colorsMap[Avatars.colorsMap.hasOwnProperty(name) ? name : '_default_'],
};

export function SpeakerAvatar({speaker, className}) {
  const avatarSrc = Avatars.sourceImage(speaker);
  const avatarBg = Avatars.avatarColor(speaker);
  const firstLetter = speaker[0].toUpperCase();
  return (
    <Avatar alt={speaker} src={avatarSrc}
            style={avatarSrc ? {} : {backgroundColor: avatarBg}}
            className={className}>
      {avatarSrc ? '' : firstLetter}
    </Avatar>
  );
}

SpeakerAvatar.hasAvatar = (name) => Avatars.hasAvatar(name);
SpeakerAvatar.supportedAvatars = (namesList) => namesList.filter(name => Avatars.hasAvatar(name));
